module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "frontmatter"
    }
  }, [_c('header', [_c('h1', {
    staticClass: "topictitle1",
    attrs: {
      "id": "to3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/nav#nto3"
    }
  }, [_c('span', {
    staticClass: "first_text"
  }, [_vm._v("Map")])])])]), _vm._v(" "), _c('div', {
    staticClass: "fignone",
    attrs: {
      "id": "id-36676-ProphetsOfTheGhostAnts_9780062429735_approved_ms_topic_9--fig-2-0-0"
    }
  }, [_c('div', {
    staticClass: "figbody"
  }, [_c('img', {
    attrs: {
      "alt": "9780062429735_PoTGAmap.jpg",
      "src": "9780062429735_PoTGAmap.jpg"
    }
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a6c76b5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Map.vue
// module id = 75
// module chunks = 0